import { withBemMod } from '@bem-react/core';
import { cnMessageBar } from '../MessageBar';
import './MessageBar_pin_brick-brick.css';
/**
 * Модификатор, отвечающий за форму сообщения.
 * @param {IMessageBarPinBrickBrickProps} props
 */
export var withPinBrickBrick = withBemMod(cnMessageBar(), {
    pin: 'brick-brick',
});
